import { CollectionNoticeStatus } from '@core/models';

export function isPaymentBilled(
  status: CollectionNoticeStatus | null
): boolean {
  return status === null
    ? false
    : [
        CollectionNoticeStatus.BILLED,
        CollectionNoticeStatus.PUBLIC_BILLED,
      ].includes(
        status
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '') as CollectionNoticeStatus
      );
}
